export default function isWindowsDesktop(userAgent) {
  if (!userAgent) return false;

  const isWindows = userAgent.indexOf('Windows');
  const isPhone = userAgent.indexOf('Windows Phone');

  return isWindows > 0 && isPhone === -1; // has to have Windows but exclude Windows Phone
}
